const TYPE='tenant'
export default [
  {
    path: "workflows",
    meta: { label: "Workflows" },
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "",
        meta: {
          requiresAuth: true,
          type: TYPE,
        },
        component: () => import("@/views/workflows/list.vue"),
        alias: "workflows"
      },
      {
        path: "create",
        meta: {
          requiresAuth: true,
          type: TYPE,
          label: 'Create'
        },
        component: () => import("@/views/workflows/create.vue"),
        alias: "createWorkflow"
      },
      {
        path: "update/:task/:version",
        meta: {
          requiresAuth: true,
          type: TYPE,
          label: 'Update'
        },
        component: () => import("@/views/workflows/update.vue"),
        alias: "updateWorkflows"
      },
      {
        path: "history",
        meta: {
          requiresAuth: true,
          type: TYPE,
          label: 'History'
        },
        component: () => import("@/views/workflows/history.vue"),
        alias: "workflowsHistory"
      },
      {
        path: "history/:workflow",
        meta: {
          requiresAuth: true,
          type: TYPE,
          label: 'Details'
        },
        component: () => import("@/views/workflows/execution-details.vue"),
        alias: "workflowsHistoryDetail"
      },
        {
            path: "mappings",
            meta: {
                requiresAuth: true,
                type: TYPE,
                label: 'Mappings'
            },
            component: () => import("@/views/workflows/events/list.vue"),
            alias: "workflowsEventMappingsList"
        },
    ],
  }
];
